export const enum TransactionType {
    Expense = 'expense',
    Income = 'income',
    Transfer = 'transfer',
    Exchange = 'exchange',
}